import { Component, Prop, Vue } from "vue-property-decorator";
import ChannelItem from "@/components/ChannelItem.vue";
import { Channel } from "@/models/channel";
import { GraphApiResult } from '@/models/graphApiResult';
import { Channels } from '@/models/channels';
import { ChannelUtils } from '@/utils/channelUtils';
import { ApiResult } from '@/enums';
import { Consts } from '@/consts';
import { GraphApiUtils } from '@/utils/graphApiUtils';
import { GroupUtils } from '@/utils/groupUtils';
import { Plans } from '@/models/plans';
import { Plan } from '@/models/plan';

@Component({
	components: {
		ChannelItem
	}
})
export default class AdminChannels extends Vue {
	@Prop() public groupName!: string;
	private channels: Channels = new Channels();
	private plans: Plans = new Plans();
	private isLoadingChannels: boolean = false;
	private groupId: string = '';
	public async created(): Promise<void> {
		if (!await GraphApiUtils.isValidAccessToken(Vue.$accessTokenInfo)) {
			this.$router.push(Consts.PATH_ADMIN);
			return;
		}
		const accessToken: string = Vue.$accessTokenInfo.token;
		await this.update(accessToken);
	}

	public async updated(): Promise<void> {
		const accessToken: string = Vue.$accessTokenInfo.token;
		await this.update(accessToken);
	}

	public async mounted(): Promise<void> {
	}


	public clickChannelItem(channelId: string): void {
		const channel: Channel | null = this.channels.get(channelId);
		if (channel === null) {
			return;
		}
		// 選択したチャンネルの画面を表示する
		const path: string = `/admin/channels/${channelId}`;
		this.$router.push(path);
	}

	private async update(accessToken: string): Promise<void> {
		const groupId: string | null = localStorage.getItem(Consts.LOCAL_STORAGE_KEY_USER_GROUPID);
		if (groupId === null) {
			return;
		}
		if ((this.groupId !== '') && (this.groupId === groupId)) {
			return;
		}
		this.groupId = groupId;
		try {
			this.plans = new Plans();
			this.channels = new Channels();
			this.isLoadingChannels = true;
			// チャンネルの取得
			const channelsResult: GraphApiResult<Channels> = await ChannelUtils.GetChannels(accessToken, groupId);
			if ((channelsResult.result !== ApiResult.Success) || (channelsResult.value === null)) {
				alert('チャンネル一覧の取得に失敗しました');
				return;
			}
			const channels: Channels | null = channelsResult.value;
			// プランの取得
			const plansResult = await GroupUtils.GetPlans(accessToken, groupId);
			if ((plansResult.result !== ApiResult.Success) || (plansResult.value === null)) {
				alert('プラン一覧の取得に失敗しました');
				return;
			}
			let plans: Plans = plansResult.value;
			// チャンネル名が違う場合を除く
			plans = plans.isChannel(channels);
			// TODO チャンネルより先にプランが取得されていることを保証してセットする
			this.plans = plans;
			this.channels = channels;
		} finally {
			this.isLoadingChannels = false;
		}
	}
}
